<template>
  <div class="overflow-x-hidden flex-grow bg-white border-l border-gray-200 overflow-y-auto flex" :data-active="active" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive" @drop.prevent="onDrop">
    <DropHere v-if="shouldShow" />
    <slot :dropZoneActive="active"></slot>
  </div>
</template>


<script>
import DropHere from "./DropHere";

export default {
  name: 'FileDropWidget',
  emits: ['files-dragged'],
  props: ['conversationTimeWindowExpired', 'canScheduleMessage'],
  components: {
    DropHere,
  },
  methods: {
    setActive() {
      if (this.widgetActive) {
        this.active = true;
        this.shouldShow = true;
      }
    },
    setInactive() {
      if (this.widgetActive) {
        this.active = false;
        this.debounceShouldShow();
      }
    },
    onDrop(e) {
      if (this.widgetActive) {
        this.setInactive();
        this.debounceShouldShow();
        if (e.dataTransfer.files) {
          this.$emit('files-dragged', e.dataTransfer.files);
        }
      }
    },
    debounceShouldShow() {
      setTimeout(() => {
        if (!this.active) {
          this.shouldShow = false;
        }
      }, 100);
    }
  },
  computed: {
    widgetActive() {
      return this.canScheduleMessage || !this.conversationTimeWindowExpired;
    }
  },
  data() {
    return {
      active: false,
      shouldShow: false,
    }
  }
}
</script>
